var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 0H5.67C2.28 0 0 2.38 0 5.92V14.09C0 17.62 2.28 20 5.67 20H14.34C17.73 20 20 17.62 20 14.09V5.92C20 2.38 17.73 0 14.34 0Z",
    className: "bg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81295 13.2485C8.58895 13.2485 8.36495 13.1635 8.19395 12.9925L5.82095 10.6195C5.47895 10.2775 5.47895 9.72345 5.82095 9.38245C6.16295 9.04045 6.71595 9.03945 7.05795 9.38145L8.81295 11.1365L12.941 7.00845C13.283 6.66645 13.836 6.66645 14.178 7.00845C14.52 7.35045 14.52 7.90445 14.178 8.24645L9.43195 12.9925C9.26095 13.1635 9.03695 13.2485 8.81295 13.2485Z",
    className: "fg"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dc4a4813107916c6e42cc1b49ccc0017.svg";
export { ForwardRef as ReactComponent };